import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

/**
 * Feel free to modify this type for this project (only) here
 * For example, if you add a whole new block of text that the jslib does not have a spot for already
 *
 * This is not necessary if you are just overriding text for a pre-existing message id
 */
type ThisProjectMessages = {
    // customMessageKey: string,
};

/**
 * Define the actual language strings here, as needed.
 * This object should be sparse, so you inherit language from the library. Only override what you need to.
 *
 * The complicated type ensures your object adheres to the library's type(s), as well as any additional type you've
 * created in ThisProjectMessages.
 */
export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    birthDate: 'Date of Birth (MM/DD/YYYY)',
    infoShared1: 'By submitting the information above, I acknowledge receipt of ',
    infoShared2: ', and I understand that my information will be shared with SheerID for verification purposes. ',
    step: {
        personalInfo: {
            subtitle: "Verify you're a student at a degree-granting college or university.",
        },
        success: {
            subtitle: 'Your student discount will automatically be applied to your shopping cart. Select <strong>Continue to Converse</strong> below to shop now.',
        },
        sso: {
            title: 'Verify using your credentials',
            subtitle: "Please sign in to your account's web portal. It will open in a new tab.",
            login: 'Sign In To My Account',
        },
        docUpload: {
            submitButtonLabel: 'Submit',
        },
    },
};
